import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';
import * as types from '@appbase/store/types';
// components

import EmailAttachmentModal from './EmailAttachmentModal.vue';

@Component({
    components: {
        EmailAttachmentModal
    },

    computed: {
        ...mapGetters({
            modal: types.MODAL_CHANGE,
        }),
    },
})
export default class ModalContainer2 extends Vue {
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    modal!: basemail.ModalOption;

    mounted() {

    }
}
